import styled from 'styled-components';

import * as Base from './base';

const FlagEmoji = styled(Base.FlagEmoji)`
  margin-top: 0.4rem;
`;

export * from './base';
export { FlagEmoji };
